export type TimeRange = "all" | "six_months" | "three_months" | "four_weeks" | "one_week";

export const TIME_RANGE_OPTIONS: { id: TimeRange; label: string }[] = [
  { id: "all", label: "Alle Daten" },
  { id: "six_months", label: "Letzte 6 Monate" },
  { id: "three_months", label: "Letzte 3 Monate" },
  { id: "four_weeks", label: "Letzte 4 Wochen" },
  { id: "one_week", label: "Letzte Woche" },
];

interface HasDate {
  date: string;
}
// Calculate cut-off date, relative to today
export function getCutoffDate(range: TimeRange): Date | null {
  if (range === "all") return null;

  const cutoff = new Date(); // today's date as orientation point

  switch (range) {
    case "six_months":
      cutoff.setMonth(cutoff.getMonth() - 6);
      break;
    case "three_months":
      cutoff.setMonth(cutoff.getMonth() - 3);
      break;
    case "four_weeks":
      cutoff.setDate(cutoff.getDate() - 28);
      break;
    case "one_week":
      cutoff.setDate(cutoff.getDate() - 7);
      break;
  }
  return cutoff;
}


// filter-function, working on any table with a "date"-row
export function filterByTimeRange<T extends HasDate>(rows: T[], range: TimeRange): T[] {
  const cutoff = getCutoffDate(range);
  if (!cutoff) return rows;
  return rows.filter((row) => new Date(row.date) >= cutoff);
}